export const paymentStatus = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded',
}

export const paymentMethods = {
  CARD: 'card',
  BANK_TRANSFER: 'bank_transfer',
  MPESA: 'mpesa',
}

export const PAYMENT_ID_EXPIRY_MILLISECONDS = 5 * 60 * 1000 // 5 minutes
export const PAYMENT_RETRY_TIMEOUT_SECONDS = 120 // 2 minutes
export const PAYMENT_REFETCH_AFTER_MILLISECONDS = 10 * 1000 // 10 seconds

export const PAYMENT_ID_KEY = 'pendingPaymentId'
export const PAYMENT_EXPIRY_KEY = 'pendingPaymentExpiry'
